import Intercom from 'common/utils/Intercom';

export default () => {
   Intercom.init();
};
